import { toast } from "sonner";
import { Check } from "lucide-react";
import { KIND_LABEL, errMsg } from "../../lib/insApi";

export const KindToggles = ({ kinds = [], onSave, tid }) => {
  const toggle = async (k) => {
    const next = kinds.includes(k) ? kinds.filter((x) => x !== k) : [...kinds, k];
    if (!next.length) return toast.error("اختر خدمة واحدة على الأقل");
    try { await onSave(next); toast.success("تم تحديث الخدمات"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={tid}>
      {Object.entries(KIND_LABEL).map(([k, l]) => {
        const on = kinds.includes(k);
        return (
          <button key={k} type="button" onClick={() => toggle(k)} data-testid={`${tid}-${k}`}
            className={`flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${on ? "border-emerald-600 bg-emerald-600 text-white" : "border-slate-200 bg-white text-slate-500 hover:border-emerald-400"}`}>
            {on && <Check className="h-3 w-3" />}{l}
          </button>
        );
      })}
    </div>
  );
};
